import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    UPDATE_GEBRUIKER_DETAIL: {
        url: "gebruiker/update-details",
        method: "post",
    },
    VALIDATE_ADDRESS: {
        url: "address/validate",
        method: "post",
    },

    SAVE_ADDRESS: {
        url: "address/save",
        method: "post",
    },
    GENERATE_LINK: {
        url: "gebruiker/generate-link",
        method: "post",
    },

    GENERATE_PASSWORD: {
        url: "gebruiker/generate-password",
        method: "post",
    },
    UPLOAD_PROFILE_PHOTO: {
        url: "gebruiker/uploadImage",
        method: "post",
    },
    GET_CONTRACT_TYPES: {
        url: "contracttypes",
        method: "get",
    },

    GET_SCHOOL_LIST: {
        url: "gebruiker/school-lists",
        method: "get",
    },

    GET_USER_ROLES: (id) => ({
        url: `gebruiker/show-user-roles?iAdminId=${id}`,
        method: "get",
    }),

    GET_COMMUNITY_LIST: (id) => ({
        url: `gebruiker/communities?iAdminId=${id}`,
        method: "get",
    }),

    UPDATE_USER_ROLE: {
        url: "gebruiker/update-role",
        method: "post",
    },

    ADD_REMOVE_COMMUNITY: {
        url: 'gebruiker/save-community',
        method: "post",
    },
       DELETE_PROFILE_IMAGE: {
        url: "deleteProfileImage",
        method: "delete",
    },

};

export const useUpdateGebruikerDetail = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_GEBRUIKER_DETAIL);

export const useValidateAddress = () =>
    useApiFetcherSWR(API_ENDPOINT.VALIDATE_ADDRESS);

export const useSaveAddress = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_ADDRESS);

export const useGenerateLink = () =>
    useApiFetcherSWR(API_ENDPOINT.GENERATE_LINK);

export const useGeneratePassword = () =>
    useApiFetcherSWR(API_ENDPOINT.GENERATE_PASSWORD);

export const useUploadProfilePhoto = () =>
    useApiFetcherSWR(API_ENDPOINT.UPLOAD_PROFILE_PHOTO);

export const useContractTypes = (communityId, enabled = true) =>
    useApiFetcherSWR(
        enabled && communityId
            ? {
                ...API_ENDPOINT.GET_CONTRACT_TYPES,
                url: `${API_ENDPOINT.GET_CONTRACT_TYPES.url}?iCommunityId=${communityId}`,
            }
            : null
    );

export const useSchoolList = (
    iCommunityId,
    iAdminId,
    enabled = true
) =>
    useApiFetcherSWR(
        enabled && iCommunityId && iAdminId
            ? {
                ...API_ENDPOINT.GET_SCHOOL_LIST,
                params: {
                    iCommunityId,
                    iAdminId,
                },
            }
            : null
    );

export const useUserRoles = (adminId, enabled = true) =>
    useApiFetcherSWR(
        enabled && adminId
            ? API_ENDPOINT.GET_USER_ROLES(adminId)
            : null
    );

export const useCommunityList = (adminId, enabled = true) =>
    useApiFetcherSWR(
        enabled && adminId
            ? API_ENDPOINT.GET_COMMUNITY_LIST(adminId)
            : null
    );
export const useUpdateUserRole = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_USER_ROLE);

export const useAddRemoveCommunity = () =>
    useApiFetcherSWR(API_ENDPOINT.ADD_REMOVE_COMMUNITY);

export const useDeleteProfileImage = (iAdminId) =>
    useApiFetcherSWR({
        ...API_ENDPOINT.DELETE_PROFILE_IMAGE,
        url: `${API_ENDPOINT.DELETE_PROFILE_IMAGE.url}?iAdminId=${iAdminId}`,
    });
